// extracted by mini-css-extract-plugin
export default {"brandTrendingWrap":"_D-z"};